// 7.1.13 ToObject(argument)
var defined = require('./_defined');
module.exports = function (it) {
  return Object(defined(it));
};



//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-react-next/~/core-js/modules/_to-object.js
// module id = ./node_modules/gatsby-plugin-react-next/node_modules/core-js/modules/_to-object.js
// module chunks = 168707334958949